import "../../../../../css/AML/Inputs/AMLInput1.css";

const TextInput = ({
  type = "text",
  placeholder = "Input 1",
  label = "",
  isRequired = false,
  error = "",
  value = "", // <-- accept value
  onChange = () => {}, // <-- accept onChange
  onBlur, // optional
  name,
  id,
  disabled = false,
  inputMode, // e.g. "numeric" for number-like fields
  autoComplete = "off",
  maxLength,
}) => {
  const inputId = id || name || label?.replace(/\s+/g, "-").toLowerCase();

  return (
    <div className="AML-Input-Container">
      {label && (
        <label className="AML-Input-Label-Container" htmlFor={inputId}>
          <div className="AML-Text-Body">{label}</div>
          {isRequired && (
            <div className="AML-Text-Body Required-Indicator">*</div>
          )}
        </label>
      )}

      <input
        id={inputId}
        name={name}
        className={`AML-Input1 AML-Text-Body ${error ? "has-error" : ""}`}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          let next = e.target.value;

          // ✅ HARD BLOCK length here
          if (typeof maxLength === "number") {
            next = next.slice(0, maxLength);
          }

          // Pass modified value upward
          onChange({
            ...e,
            target: {
              ...e.target,
              value: next,
            },
          });
        }}
        onBlur={onBlur}
        disabled={disabled}
        inputMode={inputMode}
        autoComplete={autoComplete}
        maxLength={maxLength}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
      />

      {/* {error ? (
        <div id={`${inputId}-error`} className="AML-Input-Error">
          {error}
        </div>
      ) : null} */}
    </div>
  );
};

export default TextInput;
